import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useSwot } from '../context/SwotContext';

const { FiDownload, FiUpload, FiRefreshCw, FiSave } = FiIcons;

const SwotControls = ({ onExport, onImport }) => {
  const swotData = useSwot();
  const { reset } = swotData;

  const handleSaveJson = () => {
    const { strengths, weaknesses, opportunities, threats, title, description, createdAt, updatedAt } = swotData;
    const data = {
      strengths,
      weaknesses,
      opportunities,
      threats,
      title,
      description,
      createdAt,
      updatedAt
    };
    
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `swot-analysis-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleReset = () => {
    if (confirm('Are you sure you want to reset the SWOT analysis? This action cannot be undone.')) {
      reset();
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="flex flex-wrap justify-center gap-4 mb-8"
    >
      <button
        onClick={handleSaveJson}
        className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1"
      >
        <SafeIcon icon={FiSave} className="w-5 h-5" />
        Save
      </button>
      
      <button
        onClick={onImport}
        className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1"
      >
        <SafeIcon icon={FiUpload} className="w-5 h-5" />
        Load
      </button>
      
      <button
        onClick={onExport}
        className="flex items-center gap-2 px-6 py-3 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1"
      >
        <SafeIcon icon={FiDownload} className="w-5 h-5" />
        Export Reports
      </button>
      
      <button
        onClick={handleReset}
        className="flex items-center gap-2 px-6 py-3 bg-red-600 text-white rounded-xl hover:bg-red-700 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1"
      >
        <SafeIcon icon={FiRefreshCw} className="w-5 h-5" />
        Reset
      </button>
    </motion.div>
  );
};

export default SwotControls;